"use client";

import { useState } from "react";

const navSections = [
  {
    label: "首页",
    link: "/",
  },
  {
    label: "产品服务",
    groups: [
      {
        title: "SD-WAN组网",
        items: [
          { title: "全球SD-WAN网络加速服务", link: "/sdwan" },
          { title: "光年K-WAN网络加速服务", link: "/kwan" },
          { title: "企业私有化组网", link: "/private" },
        ],
      },
      {
        title: "企业出海网络服务",
        items: [
          { title: "光年全球直播专线", link: "/liveStreaming" },
          { title: "TK直播/养号专线", link: "/tiktok" },
          { title: "全球办公网络与应用加速", link: "/saas" },
        ],
      },
    ],
  },
  {
    label: "解决方案",
    gridCols: 2,
    groups: [
      {
        title: "SD-WAN解决方案",
        items: [
          { title: "远程办公", link: "/solutions#remote-office" },
          { title: "智慧安防", link: "/solutions#smart-security" },
          { title: "IT互联网", link: "/solutions#it-internet" },
          { title: "智能交通", link: "/solutions#smart-traffic" },
          { title: "智慧医疗", link: "/solutions#smart-medical" },
          { title: "零售连锁", link: "/solutions#retail-chain" },
          { title: "智能酒店", link: "/solutions#smart-hotel" },
          { title: "智慧教育", link: "/solutions#smart-education" },
          { title: "智能制造", link: "/solutions#smart-manufacture" },
        ],
      },
    ],
  },
  {
    label: "资源中心",
    groups: [
      {
        title: "",
        items: [
          { title: "卖家 111 跨境电商导航", link: "https://maijia111.com" },
        ],
      },
    ],
  },
];

export const HeaderMobile = () => {
  const [open, setOpen] = useState(false);
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);

  const toggleSection = (idx: number) => {
    setExpandedIdx(expandedIdx === idx ? null : idx);
  };

  return (
    <>
      <div className="fixed gap-[10px] top-0 left-0 z-50 box-border w-full h-[44px] flex flex-row justify-between items-center px-[20px] py-[4.8px] border-[0.24px] border-[rgba(255,255,255,1)] bg-[rgba(255,255,255,0.4)] backdrop-blur-[2.3999998569488525px]">
        <img src="/imgs/header-mobile-logo.png" className="w-[180px] h-[34px]" />
        <div className="flex-1" />
        <a
          href="https://t22qshgkpd.jiandaoyun.com/f/68cb68e880eabb692970b84a"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer transition-all hover:opacity-90 w-[71.04px] h-[25px] flex flex-row justify-center items-center gap-[4.8px] py-[4px] rounded-[3.84px] [background:linear-gradient(135deg,rgba(89.9,185.24,255,1)_0%,rgba(191.59,152.84,255,1)_100%)]"
        >
          <span className="text-white text-[12px] font-medium">联系我们</span>
        </a>
        <img
          className="w-[18px] h-[18px] cursor-pointer"
          src="/imgs/nav.png"
          onClick={() => setOpen(!open)}
        />
      </div>

      <div
        className="fixed top-[44px] left-0 z-50 w-screen overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: open ? "calc(100vh - 44px)" : "0",
          opacity: open ? 1 : 0,
        }}
      >
        <div
          className="w-full overflow-y-auto px-[20px] py-[16px] flex flex-col gap-[4px]"
          style={{
            maxHeight: "calc(100vh - 44px)",
            background:
              "linear-gradient(135deg, rgba(181.44, 225.58, 255, 1) 0%, rgba(240.77, 225.45, 255, 1) 100%)",
          }}
        >
          {navSections.map((section, idx) => {
            if (section.link) {
              return (
                <a
                  key={idx}
                  href={section.link}
                  className="block py-[12px] px-[12px] text-[15px] font-medium text-[#333] rounded-[8px] active:bg-white/30"
                  onClick={() => setOpen(false)}
                >
                  {section.label}
                </a>
              );
            }

            const isExpanded = expandedIdx === idx;
            return (
              <div key={idx}>
                <div
                  className="flex items-center justify-between py-[12px] px-[12px] cursor-pointer rounded-[8px] active:bg-white/30"
                  onClick={() => toggleSection(idx)}
                >
                  <span className="text-[15px] font-medium text-[#333]">
                    {section.label}
                  </span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    className={`transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`}
                  >
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="#333"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div
                  className="overflow-hidden transition-all duration-200 ease-in-out"
                  style={{ maxHeight: isExpanded ? "600px" : "0" }}
                >
                  <div className="pl-[12px] pb-[8px] flex flex-col gap-[2px]">
                    {section.groups?.map((group, gIdx) => (
                      <div key={gIdx} className="flex flex-col gap-[2px]">
                        {group.title && (
                          <div className="text-[12px] text-[rgba(1,130,255,1)] py-[8px] px-[12px]">
                            {group.title}
                          </div>
                        )}
                        <div className={section.gridCols === 2 ? "grid grid-cols-2 gap-[2px]" : "flex flex-col gap-[2px]"}>
                          {group.items.map((item, iIdx) => {
                            const isExternal = item.link.startsWith("http");
                            return (
                              <a
                                key={iIdx}
                                href={item.link}
                                {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                className="block py-[10px] px-[12px] text-[14px] text-[#333] rounded-[6px] active:bg-white/40"
                                onClick={() => setOpen(false)}
                              >
                                {item.title}
                              </a>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/20"
          style={{ top: "44px" }}
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
};
